"use client";

import { useEffect } from "react";

import type { CommandIdentifierHandler } from "./context";
import useCommandPalette from "./useCommandPalette";

const useCommandPaletteRegisterHandler = (...commandIdentifierHandlers: CommandIdentifierHandler[]) => {
  const { register, unregister } = useCommandPalette();

  useEffect(() => {
    register(...commandIdentifierHandlers);

    return () => {
      unregister(...commandIdentifierHandlers.map(command => command.identifier));
    };
  }, [commandIdentifierHandlers, register, unregister]);
};

export default useCommandPaletteRegisterHandler;
